// import {API} from "../../../axios";

import { API } from "@/plugins/axios";
import swal from "sweetalert2";
import { handleRegistrationError } from "@/plugins/store/errorHandlerSwal";

const actions = {
  async getVwelcomeText({ commit }) {

    await API.post("/getText",
      {
        text_search: "vwelcome"
      })
      .then((response) => {
        commit("get_VWelcomeText", response.data.Text);
        // resolve(response)
      })
      .catch(error => {
        console.log(error);
      });
  },

  getShootingbook({ commit, rootState, rootGetters }, club_id) {
    let URL = "";
    const params = {};
    if (rootGetters["UserAuth/isLoggedIn"]) {
      API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
      URL = "/user/shootingbook";
      if (club_id) params.club_id = club_id;
    } else {
      API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
      URL = "/club/shootingbook";
    }
    API.get(URL, { params })
      .then((resp) => {
        const data = resp.data;
        commit("get_Shootingbook", data);
      })
      .catch(error => {
        handleRegistrationError(error);
      });
  },
  getShootingbookforApproval({ commit, rootState, rootGetters }, club_id) {
    let URL = "";
    const params = {};
    if (rootGetters["UserAuth/isLoggedIn"]) {
      API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
      URL = "/user/shootingbook/approval/approvals_get";
      if (club_id) params.club_id = club_id;
    } else {
      API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
      URL = "/club/shootingbook/approval/approvals_get";
    }
    return API.get(URL, { params })
      .then((resp) => {
        const data = resp.data;
        commit("get_ShootingbookApproval", data);
      })
      .catch(error => {
        handleRegistrationError(error);
      });
  },
  async setShootingRecordApproval({ dispatch, rootState, rootGetters }, Data) {
    let URL = "";
    const club_id = Data.club_id;
    if (rootGetters["UserAuth/isLoggedIn"]) {
      API.defaults.headers.common["Authorization"] = `Bearer ${rootState.UserAuth.token}`;
      URL = "/user/shootingbook/approval/approval_set";
    } else {
      API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
      URL = "/club/shootingbook/approval/approval_set";
    }
    await API.post(URL, Data)
      .then(() => {
        dispatch("getShootingbookforApproval", club_id);
      })
      .catch(error => {
        handleRegistrationError(error);
      });

  },
  getTodayMember({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.get("/club/today/users")
      .then((resp) => {
        const data = resp.data;
        commit("get_TodayMember", data);
      })
      .catch(error => {
        console.log(error);
      });
  },
  getTodaySA({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.get("/club/today/SA")
      .then((resp) => {
        const data = resp.data;
        commit("get_TodaySA", data);
      })
      .catch(error => {
        console.log(error);
      });
  },
  getTodaySL({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    API.get("/club/today/SL")
      .then((resp) => {
        const data = resp.data;
        commit("get_TodaySL", data);
      })
      .catch(error => {
        console.log(error);
      });
  },
  async end_other_aufsicht({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/today/end_other_aufsicht", Data)
      .then(() => {
        dispatch("getTodaySL");
        dispatch("getTodaySA");
      })
      .catch(error => {
        // console.log(error.response.data);
        swal.fire("Fehler", error.response.data, "warning");

      });

  },
  getClubMember({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    API.get("/club/member")
      .then((resp) => {
        const data = resp.data;
        commit("get_ClubMember", data);
      })
      .catch(error => {
        console.log(error);
      });
  },
  async setClubMemberAdmin({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/member/admin", Data)
      .then(() => {
        dispatch("getClubMember");
      })
      .catch(error => {
        console.log(error);
      });

  },
  async setClubMemberAufsicht({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/member/aufsicht", Data)
      .then(() => {
        dispatch("getClubMember");
      })
      .catch(error => {
        console.log(error);
      });
  },

  async setClubMemberMemberShip({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/member/membership", Data)
      .then(() => {
        dispatch("getClubMember");
      })
      .catch(error => {
        console.log(error);
      });
  },


  async getVerband({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.get("/club/verband")
      .then((resp) => {
        const VerbandOwn = resp.data.VerbandOwn;
        const VerbandAll = resp.data.VerbandAll;
        commit("get_Verband", { VerbandAll, VerbandOwn });
      })
      .catch(error => {
        console.log(error);
      });
  },

  async setVerband({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/verband/set", Data)
      .then(() => {
        dispatch("getVerband");
      })
      .catch(error => {
        handleRegistrationError(error);
      });

  },
  async getRanges({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.get("/club/shootingrange")
      .then((resp) => {
        const data = resp.data;
        commit("get_shootingrange", data);
      })
      .catch(error => {
        console.log(error);
      });
  },
  async setShootingRange({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/shootingrange", Data)
      .then(() => {
        dispatch("getRanges");
      })
      .catch(error => {
        handleRegistrationError(error);
      });

  },
  async updateShootingRange({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/shootingrange/update", Data)
      .then(() => {
        dispatch("getRanges");
      })
      .catch(error => {
        handleRegistrationError(error);
      });

  },

  async delShootingRange({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/shootingrange/del", Data)
      .then(() => {
        dispatch("getRanges");
      })
      .catch(error => {
        // console.log(error.response.data);
        swal.fire("Fehler", error.response.data, "warning");

      });

  },
  async getWeapons({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.get("/club/weapons")
      .then((resp) => {
        const data = resp.data;
        commit("get_Weapons", data);
      })
      .catch(error => {
        console.log(error);
      });
  },
  async setNewWeapon({ dispatch, rootState }, Data) {
    API.defaults.headers.common[
      "Authorization"
      ] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/weapons/weapon_new", Data)
      .then(() => {
        dispatch("getWeapons");
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },
  async delWeapon({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.get("/club/weapons/weapon_del", {
      params: Data
    })
      .then((resp) => {
        dispatch("getWeapons");
        swal.fire("Waffe löschen", resp.data, "success");
      })
      .catch(error => {
        // 422 = Regel aus dem WeaponObserver (z. B. Grundwaffe mit Wechselsystemen) – Klartext zeigen
        if (error.response && error.response.status === 422) {
          handleRegistrationError(error);
        } else {
          console.log(error.response);
          swal.fire("Waffe löschen", "Es ist etwas schiefgelaufen beim löschen", "warning");
        }
      });
  },

  async getTerminals({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.get("/club/passport")
      .then((resp) => {
        const Terminals = resp.data;
        commit("get_Terminals", Terminals);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async setNewTerminal({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/passport/new_client", Data)
      .then((resp) => {
        const secret = resp.data.client_secret;
        swal.fire("Terminal erfolgreich angelegt", "Bitte folgenden Secret speicher: <br><br> " + secret + "<br><br><b>Er wird nicht mehr angezeigt!</b>", "success");
        dispatch("getTerminals");
      })
      .catch(error => {
        handleRegistrationError(error);
      });
  },

  async updateTerminal({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/passport/update_client", Data)
      .then((resp) => {
        console.log(resp.data);
        dispatch("getTerminals");
      })
      .catch(error => {
        handleRegistrationError(error);
      });
  },

  async setDelTerminal({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/passport/delete_client", Data)
      .then(() => {
        dispatch("getTerminals");
        swal.fire("Terminal gelöscht", "Terminal erfolgreich gelöscht", "warning");
      })
      .catch(error => {
        console.log(error.response);
      });
  },

  async setCreateNewMember({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/member/new_single_member", Data)
      .then(() => {
        dispatch("getClubMember");
        swal.fire("Neuer Benutzer", "Neuer Benutzer erfolgreich angelegt", "success");
      })
      .catch(error => {
        const nachricht = error.response.data.message;
        swal.fire("Neuer Benutzer", "Fehler beim anlegen des Benutzer <br><br>" + nachricht, "error");
        dispatch("getClubMember");
        // console.log(nachricht);
      });
  },

  async setMemberRFIDToken({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/member/rfid_token", Data)
      .then(() => {
        dispatch("getClubMember");
        swal.fire("RFID Chip", "Dem Benutzer wurde ein RFID Chip zugewiesen", "success");
      })
      .catch(error => {
        const nachricht = error.response.data;
        swal.fire("RFID Chip", "Fehler beim anlegen des RFID Chips <br><br>" + nachricht, "error");
        // console.log(nachricht);
      });
  },

  async updateMember({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/member/update", Data)
      .then(() => {
        dispatch("getClubMember");
      })
      .catch(error => {
        handleRegistrationError(error);
      });
  },

  async setClubMemberSchiessleiter({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/member/schiessleiter", Data)
      .then(() => {
        dispatch("getClubMember");
      })
      .catch(error => {
        handleRegistrationError(error);
      });
  },

  async getWorkingHours({ commit, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.get("/club/arbeitsstunden/get", {
      params: Data
    })
      .then((resp) => {
        const data = resp.data;
        commit("set_WorkingHours", data);
      })
      .catch(error => {
        const nachricht = error.response.data.message;
        swal.fire("Arbeitsstunden", nachricht, "error");
      });
  },

  // Arbeitsstunden - Feature Actions
  async getArbeitsstundenAuswertung({ commit, rootState }, params) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.get("club/arbeitsstunden/auswertung", { params })
      .then(resp => {
        commit("SET_ARBEITSSTUNDEN_AUSWERTUNG", resp.data);
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async getArbeitsstundenFreigaben({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.get("club/arbeitsstunden/freigaben")
      .then(resp => {
        commit("SET_ARBEITSSTUNDEN_FREIGABEN", resp.data);
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async setArbeitsstundenFreigabe({ dispatch, rootState }, data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.post("club/arbeitsstunden/freigabe_set", data)
      .then(resp => {
        dispatch("getArbeitsstundenFreigaben");
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async setArbeitsstundenKorrektur({ dispatch, rootState }, data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.post("club/arbeitsstunden/korrektur", data)
      .then(resp => {
        dispatch("getArbeitsstundenFreigaben");
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async getArbeitseinsaetze({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.get("club/arbeitseinsaetze")
      .then(resp => {
        commit("SET_ARBEITSEINSAETZE", resp.data);
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async createArbeitseinsatz({ dispatch, rootState }, data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.post("club/arbeitseinsaetze", data)
      .then(resp => {
        dispatch("getArbeitseinsaetze");
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async updateArbeitseinsatz({ dispatch, rootState }, { id, data }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.put(`club/arbeitseinsaetze/${id}`, data)
      .then(resp => {
        dispatch("getArbeitseinsaetze");
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async deleteArbeitseinsatz({ dispatch, rootState }, id) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.delete(`club/arbeitseinsaetze/${id}`)
      .then(resp => {
        dispatch("getArbeitseinsaetze");
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async copyArbeitseinsatz({ dispatch, rootState }, id) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.post(`club/arbeitseinsaetze/${id}/copy`)
      .then(resp => {
        dispatch("getArbeitseinsaetze");
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async bulkStatusArbeitseinsaetze({ dispatch, rootState }, data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.post("club/arbeitseinsaetze/bulk_status", data)
      .then(resp => {
        dispatch("getArbeitseinsaetze");
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async bulkDeleteArbeitseinsaetze({ dispatch, rootState }, data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.post("club/arbeitseinsaetze/bulk_delete", data)
      .then(resp => {
        dispatch("getArbeitseinsaetze");
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async inviteMembersArbeitseinsatz({ rootState }, { id, modus = "ohne_antwort", bestaetigt = false }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.post(`club/arbeitseinsaetze/${id}/invite`, { modus, bestaetigt })
      .then(resp => {
        return resp;
      })
      .catch(error => {
        if (error.response && error.response.status === 409) {
          throw error;
        }
        handleRegistrationError(error);
        throw error;
      });
  },

  async getArbeitseinsatzMailStatus({ rootState }, id) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.get(`club/arbeitseinsaetze/${id}/mail_status`)
      .then(resp => {
        return resp.data;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async getArbeitseinsatzAntworten({ rootState }, id) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.get(`club/arbeitseinsaetze/${id}/antworten`)
      .then(resp => {
        return resp.data;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async getArbeitseinsatzMailPreview({ rootState }, id) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.get(`club/arbeitseinsaetze/${id}/mail_preview`)
      .then(resp => {
        return resp.data;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async getBeitragsgruppen({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.get("club/beitragsgruppen")
      .then(resp => {
        commit("SET_BEITRAGSGRUPPEN", resp.data);
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async createBeitragsgruppe({ dispatch, rootState }, data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.post("club/beitragsgruppen", data)
      .then(resp => {
        dispatch("getBeitragsgruppen");
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async updateBeitragsgruppe({ dispatch, rootState }, { id, data }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.put(`club/beitragsgruppen/${id}`, data)
      .then(resp => {
        dispatch("getBeitragsgruppen");
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async deleteBeitragsgruppe({ dispatch, rootState }, id) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.delete(`club/beitragsgruppen/${id}`)
      .then(resp => {
        dispatch("getBeitragsgruppen");
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async getBeitragsgruppeMembers({ commit, rootState }, id) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.get(`club/beitragsgruppen/${id}/members`)
      .then(resp => {
        commit("SET_BEITRAGSGRUPPE_MEMBERS", resp.data);
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async bulkAssignBeitragsgruppe({ dispatch, rootState }, data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.post("club/beitragsgruppen/bulk_assign", data)
      .then(resp => {
        if (data.beitragsgruppe_id) {
           dispatch("getBeitragsgruppeMembers", data.beitragsgruppe_id);
        }
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async getArbeitsstundenFunctions({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.get("club/arbeitsstunden/functions")
      .then(resp => {
        commit("SET_ARBEITSSTUNDEN_FUNCTIONS", resp.data);
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async bulkUpdateArbeitsstundenFunctions({ dispatch, rootState }, data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    return API.post("club/arbeitsstunden/functions/bulk_update", data)
      .then(resp => {
        dispatch("getArbeitsstundenFunctions");
        swal.fire("Konfiguration", "Einstellungen wurden gespeichert.", "success");
        return resp;
      })
      .catch(error => {
        handleRegistrationError(error);
        throw error;
      });
  },

  async getTerminalTelemetries({ commit, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.get("/club/terminal/telemetries", {
      params: Data
    })
      .then((resp) => {
        const telemetries = resp.data;
        commit("set_client_terminal_telemetries", telemetries);
      })
      .catch(error => {
        handleRegistrationError(error);
      });
  },
  async getTerminalRFIDLogs({ commit, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.get("/club/terminal/rfid_logs", {
      params: Data
    })
      .then((resp) => {
        const rfidlogs = resp.data;
        commit("set_client_terminal_rfidlogs", rfidlogs);
      })
      .catch(error => {
        handleRegistrationError(error);
      });
  },

  async fetchClubPoolWeapons({ commit, rootState, state }) {
    const token = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    API.defaults.headers.common["Authorization"] = token;

    const params = {};
    if (state.WeaponPoolShowOnlyActive) {
      params.only_active = true;
    }

    const response = await API.get("/club/weaponpool", { params });
    commit("SET_CLUB_WEAPON_POOL", response.data);
  },

  async addClubWeaponToPool({ dispatch, rootState }, { weapon_id, notes }) {
    const token = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    API.defaults.headers.common["Authorization"] = token;

    await API.post("/club/weaponpool/add", { weapon_id, notes })
      .then(() => {
        dispatch("fetchClubPoolWeapons");
        swal.fire("Erfolg", "Waffe hinzugefügt", "success");
      });
  },

  async removeClubWeaponFromPool({ dispatch, rootState }, weapon_pool_id) {
    const token = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    API.defaults.headers.common["Authorization"] = token;

    await API.post("/club/weaponpool/remove", { weapon_pool_id })
      .then(() => {
        dispatch("fetchClubPoolWeapons");
        swal.fire("Erfolg", "Waffe entfernt", "success");
      });
  },

  async toggleClubPoolWeapon({ dispatch, rootState }, { weapon_pool_id, is_active }) {
    const token = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    API.defaults.headers.common["Authorization"] = token;

    await API.post("/club/weaponpool/toggle", { weapon_pool_id, is_active })
      .then(() => {
        dispatch("fetchClubPoolWeapons");
      });
  },

  async updateClubWeaponPoolNotes({ dispatch, rootState }, { weapon_pool_id, notes }) {
    const token = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    API.defaults.headers.common["Authorization"] = token;

    await API.post("/club/weaponpool/update", { weapon_pool_id, notes })
      .then(() => {
        dispatch("fetchClubPoolWeapons");
        swal.fire("Erfolg", "Hinweise aktualisiert", "success");
      });
  },

  async fetchClubPoolStatistics({ commit, rootState }) {
    const token = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    API.defaults.headers.common["Authorization"] = token;

    const response = await API.get("/club/weaponpool/statistics");
    commit("SET_CLUB_WEAPON_POOL_STATISTICS", response.data);
  },

};

export default actions;
